import {Injectable} from '@angular/core';
import {Moment} from 'moment-timezone';
import {DateSelectComponentFields, DateTimeRange} from '../date-time-range-select/date-time-range-select.component';
import {momentsEqual} from '@app/shared/util/comparitors/moment-comparator';

@Injectable({providedIn: 'root'})
export class DateTimeRangeService {

  /** @deprecated use `formatMoment` */
  formatTimestamp(ts: Moment, effectiveTimezone: string, showTime: boolean, dateFormat: string, dateTimeFormat: string): string {
    return this.formatMoment(ts, effectiveTimezone, showTime ? dateTimeFormat : dateFormat);
  }

  formatMoment(ts: Moment, effectiveTimezone: string, format: string): string {
    if (ts) {
      const formattedTs = ts.format(format);
      if (ts.tz() === effectiveTimezone) {
        return formattedTs;
      } else {
        const localizedFormattedTs = ts.clone().tz(effectiveTimezone).format(format);
        return localizedFormattedTs === formattedTs
          ? formattedTs
          : localizedFormattedTs + ' ' + effectiveTimezone;
      }
    } else {
      return '';
    }
  }

  dateTimeRangesEqual(range1: DateTimeRange | null, range2: DateTimeRange | null): boolean {
    return ((range1 ?? null) === (range2 ?? null))
      || (
        momentsEqual(range1?.[DateSelectComponentFields.START_DATE], range2?.[DateSelectComponentFields.START_DATE])
        && momentsEqual(range1?.[DateSelectComponentFields.END_DATE], range2?.[DateSelectComponentFields.END_DATE])
      );
  }

  isValid(dateTimeRange: DateTimeRange | null): boolean {
    const startDate = dateTimeRange?.[DateSelectComponentFields.START_DATE] ?? null;
    const endDate = dateTimeRange?.[DateSelectComponentFields.END_DATE] ?? null;
    return startDate?.isValid() && endDate?.isValid() && endDate.isAfter(startDate);
  }
}
